import {
    GET_ACCOUNT_ALERT_TYPES_PENDING,
    GET_ACCOUNT_ALERT_TYPES_FULFILLED,
    GET_ACCOUNT_ALERT_TYPES_FAILED       
  } from "../actions/actionTypes";
  import { LoadingState } from "../helpers/enum";
  
  const initialState = {};
  
  export default function accountAlertTypesReducer(
    state = initialState,
    action
  ) {
    switch (action.type) {
      case GET_ACCOUNT_ALERT_TYPES_PENDING:
        return {
          ...state,
          [action.accountno]: { loadingState: LoadingState.PENDING }
        };
      case GET_ACCOUNT_ALERT_TYPES_FAILED:
        return {
          ...state,
          [action.accountno]: { loadingState: LoadingState.FAILED }
        };
      case GET_ACCOUNT_ALERT_TYPES_FULFILLED:
        return {
          ...state,
          [action.accountno]: {
            loadingState: LoadingState.FULFILLED,
            items: action.data
          }
        };
      default:
        return state;
    }
  }
  